<template>
  <div :class="['card', { 'bottom-margin' : isDetailedCard}]" :style="customHeight">
    <!-- NO ITEMPROP -->
    <div v-if="!isDetailedCard" class="card-content">
      <article class="media">
        <figure v-if="!showBusinessAvatar" class="media-left">
          <!-- Normal Avatar -->
          <a :href="`/profile/${authorId}`">
            <avatar v-if="authorAvatar.length > 0" :src="authorAvatar"></avatar>
            <avatar v-if="authorAvatarColor.length > 0 && authorAvatar.length === 0"
                    :backgroundColor="authorAvatarColor" :username="author"
                    color="#ffffff"></avatar>
            <avatar v-if="authorAvatarColor.length === 0 && authorAvatar.length === 0" :username="author"></avatar>
          </a>
        </figure>
        <figure v-if="showBusinessAvatar" class="media-left">
          <!-- Business Logo for avatar -->
          <a :href="`/${businessSlug}`"><img :src="getBusinessLogo" alt="Business logo" class="image"/></a>
        </figure>
        <!-- Default Review Card -->
        <div class="media-content inner-review-card">
          <h1 v-if="showBusiness"><a :href="`/${businessSlug}`" v-html="business"></a></h1>
          <p>
            <rating :review-card="compress" :stars="reviewRating"></rating>
          </p>
          <h2 v-if="!isDetailedCard"><a :href="`/${businessSlug}/reviews/${reviewSlug}`" v-html="reviewTitle"></a></h2>
          <p v-if="isDetailedCard" class="is-detail-card" v-html="reviewTitle"></p>
          <p v-if="isDetailedCard" class="author"><a :href="`/profile/${authorId}`" class="has-text-weight-bold"
                                                     v-html="author"></a>&nbsp;|&nbsp;<span
            v-html="formattedDateAndTime"></span></p>
          <p v-if="!isDetailedCard" :class="[{'ellipses': isLongReviewDescription}]" class="blurb"><a
            :href="`/${businessSlug}/reviews/${reviewSlug}`" class="description" v-html="reviewBlurb"></a></p>
          <p v-if="isDetailedCard" class="full-content" v-html="reviewBlurb"></p>
          <p v-if="!isDetailedCard && !showBusinessAvatar" class="author"><a :href="`/profile/${authorId}`"
                                                                             class="has-text-weight-bold"
                                                                             v-html="author"></a>&nbsp;|&nbsp;<span
            v-html="formattedDate"></span></p>
          <p v-if="!isDetailedCard && showBusinessAvatar" class="author">
            <span v-html="formattedDate"></span>
            <span class="is-pulled-right">
                <div class="delete-block">
                  <i class="fas fa-ellipsis-h is-pulled-right three-dot"
                     @click.prevent="showDropDown = !showDropDown"></i>
                  <transition v-if="showDropDown" name="fade">
                    <a
                      class="delete-reply button is-button-blue is-button-small is-pulled-right"
                      @click="handleDropdown({task: 'handleDeleteReview', reviewId: review.id, reviewIndex: reviewIndex, reviewPermalink: review.permalink})">Delete</a>
                  </transition>
                </div>
              </span>
          </p>
          <review-attachments :attachments="attachments"></review-attachments>

          <div v-if="isDetailedCard" class="columns is-mobile social-links">
            <div class="column is-2-desktop is-offset-1-desktop">
              <a :href="facebookShareUrl" class="social-facebook" rel="nofollow" target="_blank"><i
                class="fab fa-facebook-f"></i></a>
            </div>
            <div class="column is-2-desktop">
              <a :href="twitterShareUrl" class="social-twitter" rel="nofollow" target="_blank"><i
                class="fab fa-twitter"></i></a>
            </div>
            <div class="column is-2-desktop">
              <a :href="linkedInShareUrl" class="social-linkedin" rel="nofollow" target="_blank"><i
                class="fab fa-linkedin-in"></i></a>
            </div>
            <div class="column is-2-desktop">
              <a class="report-review" href="#" @click.prevent="reportReview"><i class="fas fa-flag"></i></a>
            </div>
          </div>
          <p
            v-if="isThankYouCard"
            class="is-hidden-desktop has-text-weight-bold has-text-centered-mobile has-text-left-tablet share-your-review" :class="{'comp-review-text': is20kComp}">{{ shareHeading }}</p>
          <div v-if="isThankYouCard" class="columns is-mobile social-links is-hidden-desktop">
            <div class="column is-2-tablet">
              <a :href="facebookShareUrl" class="social-facebook" rel="nofollow" target="_blank"><i
                class="fab fa-facebook-f"></i></a>
            </div>
            <div class="column is-2-tablet">
              <a :href="twitterShareUrl" class="social-twitter" rel="nofollow" target="_blank">
                <img src="/static/img/social/twitter_black.svg"/>
              </a>
            </div>
            <div class="column is-2-tablet">
              <a :href="linkedInShareUrl" class="social-linkedin" rel="nofollow" target="_blank"><i
                class="fab fa-linkedin-in"></i></a>
            </div>
            <div v-if="!isThankYouCard" class="column is-2-tablet">
              <a class="report-review" href="#" @click.prevent="reportReview"><i class="fas fa-flag"></i></a>
            </div>
          </div>
        </div>

        <nps v-if="showNPSRating === true" :npsRating="npsRating"></nps>
        <nps-score v-if="showNPSScore" :npsRating="npsRating"></nps-score>

        <!-- Thank You Review Card Desktop -->
        <div v-if="isThankYouCard" class="media-right is-hidden-mobile is-hidden-tablet-only">
          <div>
            <p class="has-text-centered has-text-weight-bold share-text" :class="{'comp-review-text': is20kComp}">{{ shareHeading }}</p>
            <div class="columns is-mobile social-links is-centered">
              <div class="column is-2-desktop">
                <a :href="facebookShareUrl" class="social-facebook" rel="nofollow" target="_blank"><i
                  class="fab fa-facebook-f"></i></a>
              </div>
              <div class="column is-2-desktop">
                <a :href="twitterShareUrl" class="social-twitter" rel="nofollow" target="_blank">
                  <img src="/static/img/social/twitter_black.svg"/>
                </a>
              </div>
              <div class="column is-2-desktop">
                <a :href="linkedInShareUrl" class="social-linkedin" rel="nofollow" target="_blank"><i
                  class="fab fa-linkedin-in"></i></a>
              </div>
              <div v-if="!isThankYouCard" class="column is-2-desktop">
                <a class="report-review" href="#" @click.prevent="reportReview"><i class="fas fa-flag"></i></a>
              </div>
            </div>
          </div>
        </div>
      </article>
      <p v-if="showRateBtn && !npsRating && npsRating != 0" class="nps-rating">
        <a class="button is-outlined has-icons-left" @click.prevent="submitNpsRating">RATE BUSINESS</a>
      </p>
    </div>
    <!-- ITEM PROP HERE ONLY FOR DETAILED CARD VIEW -->
    <!-- ITEM PROP ONLY FOR DETAILED CARD -->
    <div v-if="isDetailedCard" class="card-content" itemprop="review" itemscope itemtype="http://schema.org/Review">
      <article class="media">
        <figure v-if="!showBusinessAvatar" class="media-left">
          <!-- Normal Avatar -->
          <a :href="`/profile/${authorId}`">
            <avatar v-if="authorAvatar.length > 0" :src="authorAvatar"></avatar>
            <avatar v-if="authorAvatarColor.length > 0 && authorAvatar.length === 0"
                    :backgroundColor="authorAvatarColor" :username="author"
                    color="#ffffff"></avatar>
            <avatar v-if="authorAvatarColor.length === 0 && authorAvatar.length === 0" :username="author"></avatar>
          </a>
        </figure>
        <figure v-if="showBusinessAvatar" class="media-left">
          <span hidden itemprop="name" v-html="business"></span>
          <!-- Business Logo for avatar -->
          <a :href="`/${businessSlug}`"><img :src="getBusinessLogo" alt="Business logo" class="image"
                                             itemprop="url"/></a>
        </figure>
        <!-- Default Review Card -->
        <div class="media-content">
          <div hidden itemprop="author" itemscope itemtype="http://schema.org/Person">
            <span itemprop="name" v-html="author"></span>
          </div>
          <div hidden itemprop="itemReviewed" itemscope itemtype="http://schema.org/LocalBusiness">
            <div itemprop="name" v-html="business"></div>
            <div itemprop="image" itemscope itemtype="http://schema.org/ImageObject">
              <span itemprop="url" v-html="getBusinessLogo"></span>
            </div>
          </div>
          <h1 v-if="showBusiness"><a :href="`/${businessSlug}`" v-html="business"></a></h1>
          <p itemprop="reviewRating" itemscope itemtype="http://schema.org/Rating">
            <span hidden itemprop="worstRating">1</span>
            <span hidden itemprop="ratingValue" v-html="reviewRating"></span>
            <span hidden itemprop="bestRating">5</span>
            <span>{{ this.author }}</span>
          </p>
          <p>
            <span
              class="reviews-count">{{ this.author_total_reviews_count }} reviews | Active since {{ this.author_created_date | activatedFormattedDate }}</span>
          </p>
        </div>
        <nps v-if="showNPSRating === true" :big-size="true" :npsRating="npsRating"></nps>
      </article>
      <article class="media">
        <div class="media-content">
          <div class="rating-section">
            <rating :review-card="compress" :stars="reviewRating"></rating>
            <span v-html="formattedDateAndTime"></span>
          </div>
          <h2 v-if="!isDetailedCard"><a :href="`/${businessSlug}/reviews/${reviewSlug}`" itemprop="name"
                                        v-html="reviewTitle"></a></h2>
          <p v-if="isDetailedCard" class="is-detail-card" itemprop="name" v-html="reviewTitle"></p>
          <meta :content="reviewDate" itemprop="datePublished">
          <p v-if="!isDetailedCard" class="blurb"><a :href="`/${businessSlug}/reviews/${reviewSlug}`"
                                                     itemprop="reviewBody" v-html="reviewBlurb"></a></p>
          <p v-if="isDetailedCard" class="full-content" itemprop="reviewBody" v-html="reviewBlurb"></p>
          <p v-if="!isDetailedCard && !showBusinessAvatar" class="author"><a :href="`/profile/${authorId}`"
                                                                             class="has-text-weight-bold"
                                                                             v-html="author"></a>&nbsp;|&nbsp;<span
            v-html="formattedDate"></span></p>
          <p v-if="!isDetailedCard && showBusinessAvatar" class="author"><span v-html="formattedDate"></span></p>
          <review-attachments :attachments="attachments"></review-attachments>
          <p
            v-if="isThankYouCard"
            class="is-hidden-desktop has-text-weight-bold has-text-centered-mobile has-text-left-tablet share-your-review">
            Share your review now</p>
          <div v-if="isThankYouCard" class="columns is-mobile social-links is-hidden-desktop">
            <div class="column is-2-tablet">
              <a :href="facebookShareUrl" class="social-facebook" rel="nofollow" target="_blank"><i
                class="fab fa-facebook-f"></i></a>
            </div>
            <div class="column is-2-tablet">
              <a :href="twitterShareUrl" class="social-twitter" rel="nofollow" target="_blank"><i
                class="fab fa-twitter"></i></a>
            </div>
            <div class="column is-2-tablet">
              <a :href="linkedInShareUrl" class="social-linkedin" rel="nofollow" target="_blank"><i
                class="fab fa-linkedin-in"></i></a>
            </div>
            <div v-if="!isThankYouCard" class="column is-2-tablet">
              <a class="report-review" href="#" @click.prevent="reportReview"><i class="fas fa-flag"></i></a>
            </div>
          </div>
        </div>
      </article>
      <article class="social-section">
        <!-- Thank You Review Card Desktop -->
        <div v-if="isThankYouCard" class="media-right is-hidden-mobile is-hidden-tablet-only">
          <p class="has-text-centered has-text-weight-bold">Share your review now</p>
          <div class="columns is-mobile social-links is-centered">
            <div class="column is-2-desktop">
              <a :href="facebookShareUrl" class="social-facebook" rel="nofollow" target="_blank"><i
                class="fab fa-facebook-f"></i></a>
            </div>
            <div class="column is-2-desktop">
              <a :href="twitterShareUrl" class="social-twitter" rel="nofollow" target="_blank"><i
                class="fab fa-twitter"></i></a>
            </div>
            <div class="column is-2-desktop">
              <a :href="linkedInShareUrl" class="social-linkedin" rel="nofollow" target="_blank"><i
                class="fab fa-linkedin-in"></i></a>
            </div>
            <div v-if="!isThankYouCard" class="column is-2-desktop">
              <a class="report-review" href="#" @click.prevent="reportReview"><i class="fas fa-flag"></i></a>
            </div>
          </div>
        </div>
      </article>
      <div v-if="isDetailedCard" class="columns is-mobile social-links m-l-54">
        <div class="social-links-section column">
          <div class="is-2-desktop is-offset-1-desktop p-t-8">
            <a :href="facebookShareUrl" class="social-facebook" rel="nofollow" target="_blank"><i
              class="fab fa-facebook-f"></i></a>
          </div>
          <div class="is-2-desktop p-t-8">
            <a :href="twitterShareUrl" class="social-twitter" rel="nofollow" target="_blank"><i
              class="fab fa-twitter"></i></a>
          </div>
          <div class="is-2-desktop p-t-8">
            <a :href="linkedInShareUrl" class="social-linkedin" rel="nofollow" target="_blank"><i
              class="fab fa-linkedin-in"></i></a>
          </div>
        </div>
        <div class="is-2-desktop p-t-8 report-section column-right">
          <i class="fas fa-flag" @click.prevent="reportReview"></i><a class="is-hidden-mobile"
                                                                      href="#"
                                                                      @click.prevent="reportReview">Report review</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Avatar from 'vue-avatar'
import moment from 'moment'
import Rating from '@/components/Rating'
import nps from '@/components/NPS'
import npsScore from '@/components/NPSScore'
import misc from '../mixins/misc.js'
import ReviewAttachments from '@/components/ReviewAttachments'

export default {
  name: 'ReviewCard',
  mixins: [misc],
  props: {
    author_total_reviews_count: {
      default: 1
    },
    author_created_date: {
      type: String
    },
    author: {
      type: String,
    },
    authorId: {
      type: String
    },
    authorAvatar: {
      type: String,
      default: ''
    },
    authorAvatarColor: {
      type: String,
      default: ''
    },
    review: {
      type: Object
    },
    reviewRating: {
      type: Number,
      default: 1
    },
    business: {
      type: String
    },
    businessSlug: {
      type: String
    },
    reviewSlug: {
      type: String
    },
    reviewTitle: {
      type: String
    },
    reviewBlurb: {
      type: String
    },
    reviewDate: {
      type: String
    },
    reviewBusinessReporting: {
      type: Object
    },
    showBusiness: {
      type: Boolean,
      default: true
    },
    isDetailedCard: {
      type: Boolean,
      default: false
    },
    isThankYouCard: {
      type: Boolean,
      default: false
    },
    showBusinessAvatar: {
      type: Boolean,
      default: false
    },
    businessLogo: {
      type: String,
      default: ''
    },
    industryLogo: {
      type: String,
      default: ''
    },
    customHeight: {
      type: String,
      default: ''
    },
    showNPSRating: {
      type: Boolean,
      default: false
    },
    npsRating: {
      type: Number,
      default: 0
    },
    showRateBtn: {
      type: Boolean,
      default: false
    },
    showNPSScore: {
      type: Boolean,
      default: false
    },
    attachments: {
      type: Array,
      default: () => []
    },
    consumerComp: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Avatar,
    Rating,
    nps,
    npsScore,
    ReviewAttachments
  },
  data () {
    return {
      compress: true,
      showDropDown: false,
      modelOptions: {
        title: 'Report review',
        body: '',
        btn_action_title: 'REPORT REVIEW',
        show_btns: true,
        show_cancel_btn: false,
        show_close_btn: true,
        task: 'reportReviewCallback',
        setWidthAuto: true,
        isReportReview: true,
        businessSlug: this.businessSlug,
        reviewSlug: this.reviewSlug,
        producer: {}
      }
    }
  },
  filters: {
    /**
     * Returns reviewer created date format
     *
     * returns {string}
     */
    activatedFormattedDate (date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('MMM YYYY')
    }
  },
  computed: {
    is20kComp () {
      return this.consumerComp.includes('20k')
    },
    shareHeading () {
      if (this.consumerComp.includes('20k')) {
        return 'Boost your chances of winning by sharing your experience on social media and tagging #ReviewstoRiches!'
      }
      return 'Share your review now'
    },
    formattedDate () {
      return moment(this.reviewDate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY')
    },
    formattedDateAndTime () {
      return moment(this.reviewDate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY, HH:mm')
    },
    facebookShareUrl () {
      return `https://www.facebook.com/sharer.php?u=${process.env.APP_URL}/${this.businessSlug}/reviews/${this.reviewSlug}`
    },
    twitterShareUrl () {
      const text = this.twitter_share_text({author: this.author, bizName: this.business, rating: this.reviewRating, consumerCompetitions: this.consumerComp})
      return `https://twitter.com/share?url=${process.env.APP_URL}/${this.businessSlug}/reviews/${this.reviewSlug}&text=${text}`
    },
    linkedInShareUrl () {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${process.env.APP_URL}/${this.businessSlug}/reviews/${this.reviewSlug}`
    },
    getBusinessLogo () {
      if (this.businessLogo !== null && this.businessLogo.length > 0) {
        return this.businessLogo
      }
      return this.noLogo.url
    },
    /**
     * Returns report review blog url
     *
     * @returns {string}
     */
    reportReviewUrl () {
      return process.env.REPORT_PAGE_URL
    },
    /**
     * Check if review description has any specific length
     * @return {boolean}
     **/
    isLongReviewDescription () {
      return this.reviewBlurb.length > 250
    }
  },
  created () {
    if (this.isDetailedCard) {
      window.events.$emit('review-detail-loaded', {
        author: this.author,
        reviewDate: this.reviewDate
      })
      window.events.$on('reportedReviewComplete', (data) => {
        let options = ''
        if (data.header === 'is-success') {
          options = {
            'title': 'Thanks for reporting this review',
            'body': `<p>You'll hear back from us within the next two business days.</p>
                  <p style="margin-top: 6px;">While you're waiting, check out what happens when <br/>you <a style="text-decoration: underline;" target="__blank" href="${this.reportReviewUrl}">report a review</a> </p>`,
            'btn_action_title': 'OK',
            'show_btns': true,
            'show_cancel_btn': false,
            'show_close_btn': false,
            'setWidthAuto': true,
            'isReportSucsess': true,
            'task': 'refreshReviewDetail',
            'businessSlug': this.businessSlug,
            'reviewSlug': this.reviewSlug,
            'producer': {}
          }
        }
        modal(options)
        window.scrollTo(0, 0)
      })
    }
  },
  methods: {
    reportReview () {
      if (this.reviewBusinessReporting) {
        if (this.reviewBusinessReporting.status !== 'RESOLVED') {
          this.modelOptions = {
            title: 'This review has already been reported',
            body: `<p>This review has already been reported and our operations
                            team has been notified.</p><br>
                        <p>Thanks for keeping Hellopeter an authentic space! </p>`,
            btn_action_title: 'OK',
            task: '',
            show_btns: true,
            setWidthAuto: true,
            isReportSucsess: true,
          }
        }
      }
      modal(this.modelOptions)
      window.scrollTo(0, 0)
    },
    reportReviewCallback (options) {
      console.log('reportReviewCallback', options)
    },
    submitNpsRating () {
      const options = {
        'title': 'Rate Business',
        'show_btns': false,
        'show_cancel_btn': false,
        'show_close_btn': true,
        'task': 'npsRatingCallback',
        'setWidthAuto': false,
        'middleLarge': true,
        'isReportReview': false,
        'isUpdatePassword': false,
        'isNpsRating': true,
        'hide_submit_btn': true,
        'reviewSlug': this.reviewSlug,
        'reviewPermalink': this.reviewPermalink,
        'business': this.business
      }
      modal(options)
    },
    /**
     * Handling delete review
     * @param {object} obj
     * @return {void}
     */
    handleDropdown (obj) {
      this.showDropDown = false
      window.events.$emit(obj.task, obj)
    },
  }
}
</script>
<style scoped>
.comp-review-text {
  font-size: 1rem !important;
}

.card {
  border: 1px solid #C9C9C9;
  box-shadow: none;
}

.card.bottom-margin {
  margin-bottom: 2rem;
}

a, a:hover, a:visited {
  text-decoration: none;
  color: #58595B;
}

.media-content {
  width: 90%;
}

.media-content.inner-review-card {
  overflow: hidden;
  width: 100%
}

.media-content > h1 {
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.media-content > h2 {
  font-weight: bold;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  margin-right: 2rem;
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.media-content .description, .media-content .description p {
  display: inline-block;
  overflow: hidden;
  max-height: 4.6em;
}

.media-content > .is-detail-card {
  font-size: 1rem;
  font-weight: bold;
  width: 90%;
  word-wrap: break-word;
  display: inline-block;
}

.media-content > .blurb {
  font-size: 0.9rem;
  overflow: hidden;
  position: relative;
  /* use this value to count block height */
  line-height: 1.4rem;
  /* max-height = line-height (1.2) * lines max number (3) */
  max-height: 4.2rem;
  /* fix problem when last visible word doesn't adjoin right side  */
  text-align: left;
  /* place for '...' */
  margin-right: 2rem;
  padding-right: 1rem;
  word-break: break-word;
}

.media-content > .full-content {
  font-size: 0.9rem;
  line-height: 1.4rem;
  text-align: left;
  margin-right: 2rem;
  padding-right: 1rem;
  margin-top: 1.5rem;
  white-space: pre-wrap;
  word-break: break-word;
}

.media-content > .ellipses:before {
  content: '...';
  position: absolute;
  right: 0;
  bottom: 0;
}

.media-content > .blurb:after {
  content: '';
  position: absolute;
  right: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.2em;
  background: #ffffff;
}

.author {
  color: #8A8C91;
  font-size: 0.7rem;
  margin-top: 1.2rem;
}

.author a, .author a:hover, .author a:visited {
  text-decoration: none;
  color: #8A8C91;
}

.social-links {
  margin-top: 3px;
}

.social-facebook, .social-linkedin, .report-review, .social-facebook:hover, .social-linkedin:hover, .report-review:hover, .social-facebook:visited, .social-linkedin:visited, .report-review:visited, .social-twitter, .social-twitter:hover, .social-twitter:visited {
  display: block;
  width: 37px;
  margin-left: auto;
  margin-right: 8px;
}

.social-facebook, .social-linkedin, .report-review, .social-facebook:hover, .social-linkedin:hover, .report-review:hover, .social-facebook:visited, .social-linkedin:visited, .report-review:visited {
  color: #ffffff;
  height: 37px;
  border-radius: 50%;
  font-size: 1.3rem;
  line-height: 37px;
  text-align: center;
}

.social-facebook {
  background-color: #3B5998;
}

.social-linkedin {
  background-color: #0E76A8;
}

.report-review {
  background-color: #EAB013;
}

.media-right {
  align-items: center;
  display: flex;
  border-left: 1px solid #C9C9C9;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.media-right > div > p {
  font-size: 1.4rem;
  margin-left: 1.4rem;
}

.share-your-review {
  font-size: 1.4rem;
  margin-top: 40px;
  color: #58595B;
  border-top: 1px solid #C9C9C9;
  padding-top: 1.5rem;
}

.media-left > a > .image {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.p-t-8 {
  padding-top: 8px;
}

.nps-rating {
  position: absolute;
  right: 25px;
  top: 20px;
}

.nps-rating a {
  border: 1px solid grey;
  border-radius: 0;
  padding: 1.3rem 2rem;
  font-size: 0.85rem;
}

/* Delete Reply CSS Begin */
.three-dot {
  cursor: pointer;
}

.delete-reply {
  position: absolute;
  color: #000;
  background-color: #fff !important;
  border-color: #dbdbdb !important;
  margin-top: 12px;
  margin-right: -14px;
  right: 53px;
}

a.delete-reply:hover {
  color: #000 !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.delete-block {
  padding-right: 15px;
}

/* Delete Reply CSS End */

@media screen and (min-width: 768px) {
  .m-l-54 {
    /*margin-left: 54px;*/
  }
}

@media screen and (max-width: 767px) {
  .media-content > .blurb, .media-content > .full-content {
    margin-right: 1rem;
  }

  .card {
    border: none;
    border-top: 1px solid #C9C9C9;
  }

  .card.bottom-margin {
    margin-bottom: 0;
    border: none;
    border-bottom: 1px solid #C9C9C9;
  }

  .card.bottom-margin ~ .card {
    margin-bottom: 0;
    border: none;
    border-bottom: 1px solid #C9C9C9;
    margin-top: 0;
  }

  .is-review-details .card {
    margin-bottom: 0;
    margin-top: 0;
  }

  .is-review-details .card .media-left {
    display: none;
  }

  .card.bottom-margin ~ .card .media-left {
    display: none;
  }

  .card.bottom-margin .media-content {
    overflow: unset;
  }

  .card.bottom-margin .media-content, .card.bottom-margin .media-content > .is-detail-card, .card.bottom-margin .media-content > h1, .card.bottom-margin .media-content > h2 {
    width: 100%;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
  }

  .card.bottom-margin .media-content > .full-content {
    margin-right: 0;
    padding-right: 0;
  }

  .nps-rating {
    position: relative;
    right: 0;
    top: 0;
  }

  .nps-rating a {
    display: block;
    text-align: center;
    display: flex;
  }
}

.rating-section {
  display: flex;
  position: relative;
}

.rating-section > span {
  font-size: 0.9rem;
  position: absolute;
  right: 0px !important;
}

.social-links-section {
  display: flex;
}

.report-section {
  width: 100%;
  text-align: right;
  margin-top: 20px;
  margin-right: 14px;
}

.report-section > a {
  text-decoration: underline;
  margin-left: 10px;
  font-size: 0.9rem;
}

.social-section {
  border-top: 1px solid rgba(219, 219, 219, 0.5);
}

.reviews-count {
  font-size: 0.9rem;
}

.fas.fa-flag {
  cursor: pointer;
}

.media-content h2 a {
  word-wrap: break-word;
}

.media {
  align-items: normal;

  .share-text {
    width: 256px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReviewCard.vue